import { postalCodePattern } from '@alliander-fe/validation';
import { useRouter } from 'next/router';
import { baseQueryParams, forceString } from 'src/utils';
import { amountOfActiveFilters } from 'src/components/CongestionReportsOverview/utils/amountOfActiveFilters';
import { useParams } from '../../../hooks/useParams';

export const useSetFilters = (availableFilters: string[]) => {
  const router = useRouter();
  const urlParams = useParams();
  const path = router.query.path || [];
  const pathname = typeof path === 'string' ? path : path.join('/');
  const params = new URLSearchParams();

  const activeFilters = amountOfActiveFilters(urlParams, availableFilters);

  const setFilter = (filters: Partial<Record<keyof typeof baseQueryParams, string>>) => {
    const location = path[path.length - 1];
    const locationIsPostalCode = path ? postalCodePattern.value.test(location) : false;

    const postalCode = !locationIsPostalCode
      ? filters.postalCode || forceString(urlParams.postalCode)
      : undefined;

    const setFilters = {
      ...urlParams,
      ...filters,
      postalCode,
    };

    for (const filter in urlParams) {
      const key = filter as keyof typeof baseQueryParams;
      if (setFilters[key] && key !== 'page') {
        params.set(baseQueryParams[key], setFilters[key]);
      }
    }

    router.push({ pathname, search: params.toString() }, undefined, { scroll: false });
  };

  const clearFilters = () => {
    router.push({ pathname }, undefined, { scroll: false });
  };

  return { setFilter, clearFilters, activeFilters };
};
